import React from "react";
import BookingFlow from "@/components/BookingFlow";

const CastlewoodBooking = () => <BookingFlow brand="castlewood" />;
export default CastlewoodBooking;
